import { Collapse, Divider, Fade, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from '../../Store/hooks';
import { SelectStatus } from '../../Store/Selectors';
import './shipment-non-trackable-error.component.scss';

export const ShipmentNonTrackableErrorComponent: React.FC = () => {
  const status = useAppSelector(SelectStatus);
  const isVisible = status.error?.status === 405;

  return (
    <div className='shipment-non-trackable list-box-shadow mt-2'>
      {!!isVisible && (
        <Collapse in={isVisible} timeout={700}>
          <Fade in={isVisible} timeout={700}>
            <Paper className='py-2 px-4 status-paper'>
              <h3 className='my-2'>{status.error?.message}</h3>
              <Divider className='mb-2' />
              <p>
                Bitte beachten Sie, dass es sich bei Ihrem Brief um einen Standardbrief handelt, der nicht nachverfolgbar ist.
                Wir gehen davon aus, dass die Zustellung innerhalb der nächsten Werktage erfolgt. Sollte Ihr Brief auch nach 8 Werktagen
                nicht eingetroffen sein, wenden Sie sich bitte für eine Ersatzlieferung oder Erstattung an den Absender.
                Unabhängig davon können Sie uns den Verlust der Sendung über unser <a
                  href="https://www.pin-ag.de/servicecenter/sendungsverfolgung-recherche/formular-sendungsrecherche"
                  rel="noreferrer"
                  target="_blank">Kontaktformular</a> melden.
              </p>
            </Paper>
          </Fade>
        </Collapse>
      )}
    </div>
  );
};
